import MailIcon from "@mui/icons-material/Mail";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button, Toolbar, Typography } from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/AuthProvider";
import { NotificationContext } from "../../context/NotificationContext";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import useApi from "../../service/api.service";
import { customDateConvert } from "./Utils/Utils";
import CustomSkeleton from "./CustomSkeleton";
import AlertFilter from "./AlertFilter";
import CancelIcon from "@mui/icons-material/Cancel";

const iconStyle = {
  ml: 1,
  fontSize: "18px",
  color: "#9F9F9F",
  cursor: "pointer",
};
function SidePanelHeader({
  type,
  id,
  page,
  handleClose = () => console.log("close"),
}) {
  const { setSelectedItemIds1, setSelectedItemIds, alertData, setAlertData } =
    useContext(NotificationContext);
  const API = useApi();
  const [loading, setLoading] = useState(false);

  const buttonStyle = (buttonName) => ({
    textTransform: "capitalize",
    color: "#404040",
    fontSize: "12px",
    padding: "3px 15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "30px",
    cursor: "default",
    position: "sticky",
    top: 0,
    zIndex: 1000,
    backgroundColor: "white",
  });
  const [filters, setFilters] = useState("All");
  const [factorData, setfactorData] = useState([]);

  const fetchData = async () => {
    const body = {
      alertType: filters === "All" ? null : filters,
    };
    try {
      setLoading(true);
      const response = await API.fetchAlertsData(body);
      const response1 = await API.getConfigurationData();
      setfactorData(response1.data);
      setLoading(false);
      setAlertData(response.data);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  const navigate = useNavigate();

  const handleRedirect = (id, prevData) => {
    localStorage.setItem("currentState", prevData);
    navigate(`/qualityInfo/${id}`, { state: { prevData } });
  };

  const handleRedirectToQC = (factorId) => {
    const factor = factorData.find(
      (item) => item.factorId === parseInt(factorId)
    );
    if (factor && factor?.factorType === "Type 1") {
      setSelectedItemIds([parseInt(factorId)]);
    }
    if (factor && factor?.factorType === "Type 2") {
      setSelectedItemIds1([parseInt(factorId)]);
    }
    navigate("/control");
  };

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <div style={buttonStyle("Alerts")}>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <ReportProblemIcon
            sx={{
              fontSize:
                page === "QualityHome" || page === "production"
                  ? "18px"
                  : "14px",
              color:
                page === "QualityHome" || page === "production"
                  ? "#EA8600"
                  : "black",
            }}
          />
          Alerts ({alertData.length})
        </div>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <AlertFilter filters={filters} setFilters={setFilters} />
          {page === "production" && (
            <CancelIcon
              sx={{
                color: "#9F9F9F",
                cursor: "pointer",
                "&: hover": { color: "#FD5707" },
              }}
              onClick={handleClose}
            />
          )}
        </div>
      </div>
      <div
        style={{
          backgroundColor: "white",
          overflow: "auto",
          borderTop: "1px solid #E4E4E4",
          flexGrow: 1,
        }}
      >
        {loading ? (
          <CustomSkeleton height="100vh" />
        ) : (
          <>
            {alertData.length > 0 ? (
              alertData.map((alert, index) => {
                if (alert?.alertType === "Prediction") {
                  return (
                    <div
                      key={index}
                      style={{
                        width: "100%",
                        borderTop: "1px solid #E4E4E4",
                        padding: "12px",
                        fontSize: "12px",
                        font: "Montserrat, sans-serif",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <div>
                          {customDateConvert(
                            alert?.alertTimestamp,
                            "MM/DD/YYYY HH:mm:ss"
                          )}
                        </div>
                        <div>
                          <OpenInNewIcon
                            onClick={() =>
                              handleRedirect(alert?.relationId, "By Parts")
                            }
                            sx={iconStyle}
                          />
                        </div>
                      </div>
                      <div>
                        Part ID:{" "}
                        <span
                          style={{
                            textDecoration: "underline",
                            color: "#0077B6",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleRedirect(alert?.relationId, "By Parts")
                          }
                        >
                          {alert?.alertMessage
                            ?.split("PartID:")[1]
                            ?.split(" ")[0] || alert?.relationId}
                        </span>{" "}
                        has been predicted to scrap.
                      </div>
                    </div>
                  );
                }
                if (alert?.alertType === "Limit Breached") {
                  return (
                    <div
                      key={index}
                      style={{
                        width: "100%",
                        borderTop: "1px solid #E4E4E4",
                        padding: "12px",
                        fontSize: "12px",
                        font: "Montserrat, sans-serif",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <div>
                          {customDateConvert(
                            alert?.alertTimestamp,
                            "MM/DD/YYYY HH:mm:ss"
                          )}
                        </div>
                        <div>
                          <OpenInNewIcon
                            onClick={() =>
                              handleRedirectToQC(alert?.relationId)
                            }
                            sx={iconStyle}
                          />
                        </div>
                      </div>
                      <div>
                        The factor{" "}
                        <span
                          style={{
                            textDecoration: "underline",
                            color: "#0077B6",
                            cursor: "pointer",
                          }}
                          onClick={() => handleRedirectToQC(alert?.relationId)}
                        >
                          {alert?.alertMessage?.split(" ")?.[2] || ""}
                        </span>{" "}
                        is outside the design limits
                      </div>
                    </div>
                  );
                }
              })
            ) : (
              <div
                style={{
                  width: "100%",
                  borderTop: "1px solid #E4E4E4",
                  // height: "75px",
                  padding: "12px",
                  fontSize: "12px",
                  font: "Montserrat, sans-serif",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    alignItems: "center",
                    color: "red",
                  }}
                >
                  No Alerts
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default SidePanelHeader;
